import { FulfillmentStatus, OrderStatus as ProtoOrderStatus } from '@wix/ambassador-ecom-v1-order/types';
import { RestaurantsOrderStatus } from '@wix/restaurants-types';
export function order() {
  const now = () => new Date();
  const defaultPrice = () => ({
    amount: '0',
    formattedAmount: '$0'
  });
  return {
    id: '',
    number: '1',
    createdDate: now(),
    updatedDate: now(),
    lineItems: [],
    status: ProtoOrderStatus.APPROVED,
    fulfillmentStatus: FulfillmentStatus.NOT_FULFILLED,
    billingInfo: {
      contactDetails: {
        firstName: null,
        lastName: null,
        phone: null,
        company: null
      }
    },
    priceSummary: {
      subtotal: defaultPrice(),
      shipping: defaultPrice(),
      tax: defaultPrice(),
      discount: defaultPrice(),
      totalPrice: defaultPrice(),
      total: defaultPrice(),
      totalWithGiftCard: defaultPrice(),
      totalWithoutGiftCard: defaultPrice(),
      totalAdditionalFees: defaultPrice()
    },
    fulfillmentStatusesAggregate: {
      statuses: [RestaurantsOrderStatus.PENDING_APPROVAL]
    }
  };
}
//# sourceMappingURL=order.js.map